import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import StoreLocator from "../components/storelocator/storeLocator"

const Stores = (props) => {
  return (
    <Layout {...props} backgroundColor={"#FFF"}>
      <SEO
        title="Store Locator"
      />
      <StoreLocator />
    </Layout>
  )
}

export default Stores
